import * as Schema from "effect/Schema";

/** Values are write-only. Saved and client-visible definitions carry references. */
export const McpSecret = Schema.Struct({
  value: Schema.optionalKey(Schema.String),
  reference: Schema.optionalKey(Schema.String),
});
export type McpSecret = typeof McpSecret.Type;
const NamedSecret = Schema.Struct({ name: Schema.String, secret: McpSecret });
const common = { name: Schema.String, enabled: Schema.Boolean };
export const McpDefinition = Schema.Union([
  Schema.Struct({
    ...common,
    transport: Schema.Literal("stdio"),
    command: Schema.String,
    args: Schema.Array(Schema.String),
    environment: Schema.Array(NamedSecret),
  }),
  Schema.Struct({
    ...common,
    transport: Schema.Literal("http"),
    url: Schema.String,
    bearerToken: Schema.optionalKey(McpSecret),
    headers: Schema.Array(NamedSecret),
  }),
]);
export type McpDefinition = typeof McpDefinition.Type;
